import BasicCrudAPI from './basicCrud.api.js'

const END_POINT = '/categoryTierGroups'

class CategoryTierGroupAPIClass extends BasicCrudAPI {
  constructor() {
    super(END_POINT)
  }

  addCategory(id, { categoryId, minRpc, maxRpc, position }) {
    return this.httpClient.post(`${END_POINT}/${id}/categories`, {
      categoryId,
      minRpc,
      maxRpc,
      position
    })
  }

  removeCategory(id, categoryId) {
    return this.httpClient.delete(`${END_POINT}/${id}/categories/${categoryId}`)
  }

  reorderCategories(id, orderedCategoryIds) {
    return this.httpClient.patch(`${END_POINT}/${id}/categories/order`, {
      orderedCategoryIds
    })
  }

  updateRpcBounds(id, categoryId, { minRpc, maxRpc }) {
    return this.httpClient.patch(`${END_POINT}/${id}/categories/${categoryId}/rpcBounds`, {
      minRpc,
      maxRpc
    })
  }
}

const CategoryTierGroupAPI = new CategoryTierGroupAPIClass()

export default CategoryTierGroupAPI
